module.exports = __webpack_public_path__ + "static/media/3.a4b886c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/how-signup-works/3.jpg
// module id = 392
// module chunks = 0